const selfPromo = 'I\'m trying to bring more resources to my classroom to help my students thrive. ' +
        'If you\'re looking for a simple way to support my class, this is it. 💛';
const generalPromo = "Teachers need the right tools to help their students excel. If you're looking for a simple way to support public schools, this is it!";

const InterstitialPopup = ({ link }:{ link:string }) => {
    return <div className="fb-interstitial">
        <h2>Preparing your post...</h2>
        <p className="subheader">We&#39;ve copied a friendly message to your clipboard for you to paste and share with your
            network.</p>
        <p className="copied-friendly-message">
            {'teacherId' in window && window.teacherId === window.userId ? selfPromo : generalPromo}
        </p>
        <div className="fb-not-open-link" style={{marginTop: '0'}}>
            Facebook not opening? <br/><a className="button-secondary small" href={link} target="_blank"
                rel='noreferrer' style={{marginTop: '.5rem'}}>Open Facebook</a>
        </div>
    </div>;
};

export default InterstitialPopup;
